import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginAsAdminComponent from "./LoginAsAdminComponent";

const LoginAsAdmin = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin');
    }

    return (
        <LoginAsAdminComponent redirectAdmin = { () => redirect() } />
    );

}

export default LoginAsAdmin;